import EmailIcon from '@mui/icons-material/Email'

export const EmailApprovalIcon = EmailIcon
export default EmailApprovalIcon
